import React from "react";
import logoHeader from "../assets/logo-header.png";
import fb from "../assets/fb.png";
import insta from "../assets/insta.png";
import linkedin from "../assets/linkedin.png";
import pin from "../assets/pin-outline.png";
import phone from "../assets/phone-black.png";
import email from "../assets/email-black.png";
import { Link } from "react-router";
import ScrollToTop from "../components/scrolltoTop";

export const Footer = () => {
  return (
    <footer className="bg-white px-6 py-12 md:px-28 text-gray-600">
      <ScrollToTop></ScrollToTop>
      <div className="flex col flex-wrap md:flex-row flex-col gap-8 justify-between">
        <div>
          <img src={logoHeader} alt="BE Logo" className="mb-4" />
        </div>
        <div className="width-nav">
          <ul className="space-y-2 text-sm foot-nav-list">
            <li>
              <Link to="/" className="hover:underline">
                Home
              </Link>
            </li>
            <li>
              <Link to="/about" className="hover:underline">
                About us
              </Link>
            </li>
            <li>
              <Link to="/services" className="hover:underline">
                What We Do
              </Link>
            </li>
          </ul>
        </div>
        {/* Navigation */}
        <div className="padding-top-mobile">
          <ul className="space-y-2 text-sm foot-nav-list">
            <li>
              <Link to="/projects" className="hover:underline">
                Our Projects
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:underline">
                Contact Us
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-4 foot-heading">Contact Us</h4>
          <p className="foot-para-val flex">
            <img className="h-7" src={pin} alt="Address" />
            Floor GRD Godwan-62 Madhuli Building,<br></br>
            Vitthalbhai Patel Road Girgaon Maharashtra Mumbai - 400004
          </p>
          <p className="foot-para-val mt-2 flex">
            <img className="h-7" src={email} alt="Email" />
            <a
              href="mailto:bhagwatiengineering76@gmail.com"
              className="hover:underline"
            >
              bhagwatiengineering76@gmail.com
            </a>
          </p>
          <p className="foot-para-val flex">
            <img className="h-7" src={phone} alt="Phone" />
            <a href="tel:+918291724184" className="hover:underline">
              +91 8291724184
            </a>
          </p>
        </div>
        {/* Social Media */}
        <div>
          <h4 className="font-semibold mb-4 foot-heading">Social Media</h4>
          <div className="flex gap-4">
            <img src={insta} alt="Instagram" className="h-9" />
            <img src={linkedin} alt="LinkedIn" className="h-9" />
            <img src={fb} alt="Facebook" className="h-9" />
          </div>
        </div>
      </div>

      {/* Bottom note */}
      <div className="text-sm mt-12 flex items-center flex-wrap justify-between">
        <p className="copyright">© COPYRIGHT 2025 ALL RIGHTS RESERVED</p>

        <p className="copyright">
          {" "}
          DESIGNED & DEVELOPED BY{" "}
          <span className="font-bold">QUINDARA INC</span>
        </p>
      </div>
    </footer>
  );
};
